/* @flow */

import * as React from 'react';
import { useCallback, useRef } from 'react';

import type { SimpleProfile } from '../../../helpers/gaming/types';
import type { ModalState } from '../../../redux/modal/reducers';

import Localizer from '../../../helpers/localization';
import Modal, { ModalView } from '../modal';
import './GameProfileSelectModal.css';
import Profile from './Profile';

export type GAME_PROFILE_SELECT_DATA_MODAL_TYPE = {
  profiles: Array<SimpleProfile>,
  preselectedProfileId: string | null,
};

const GameProfileSelectModal = ({ gameProfileSelectData }: ModalState): React.Node => {
  const modalRef = useRef<ModalView | null>(null);

  const setModalRef = useCallback((instance: ModalView | null) => {
    modalRef.current = instance;
  }, []);

  const close = useCallback((profileId: string | null) => {
    modalRef.current?.close(profileId);
  }, []);

  const renderProfiles = useCallback((): React.Node => {
    if (!gameProfileSelectData) {
      return null;
    }

    const { preselectedProfileId, profiles } = gameProfileSelectData;

    return (
      <div className='gameProfileSelect'>
        {profiles.map(({ avatarUrl, nickname, profileId }) => (
          <Profile avatarUrl={avatarUrl} isSelected={preselectedProfileId === profileId} key={profileId} nickname={nickname} profileId={profileId} selectProfile={close} />
        ))}
      </div>
    );
  }, [close, gameProfileSelectData]);

  if (!gameProfileSelectData) {
    return null;
  }

  return (
    <Modal
      ariaLabel={Localizer.localize('accessibility.modal.game_profile_selection')}
      className='gameProfileSelect'
      header={Localizer.localize('gaming.profile_selection.title')}
      innerRef={setModalRef}
    >
      {renderProfiles()}
    </Modal>
  );
};

export default GameProfileSelectModal;
